"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityIdField = exports.entityHiddenNameField = exports.entityHiddenField = void 0;
var input_hidden_1 = require("../components/forms/input-hidden");
var entityHiddenField = function (_a) {
  var context = _a.context,
    name = _a.name;
  return {
    name: name,
    focus: false,
    render: input_hidden_1.createInputHidden,
    hidden: true
  };
};
exports.entityHiddenField = entityHiddenField;
var entityHiddenNameField = function (_a) {
  var context = _a.context;
  return (0, exports.entityHiddenField)({
    context: context,
    name: 'name'
  });
};
exports.entityHiddenNameField = entityHiddenNameField;
var entityIdField = function (_a) {
  var context = _a.context;
  return (0, exports.entityHiddenField)({
    context: context,
    name: 'id'
  });
};
exports.entityIdField = entityIdField;